module.exports = __webpack_public_path__ + "static/media/bg-tires-steps.06df787b.jpg";